import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const NoTouchPurchaseSummaryModalContent = styled(Flex)<{ $isLoading: boolean }>`
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: ${({ $isLoading }) => ($isLoading ? "center" : "space-between")};
`;

export const NoTouchPurchaseSummaryModalError = styled(Flex)`
    gap: 8px;
    width: 100%;
    background-color: ${colorsPalettes.red[100]};
    border-radius: 3px;
    min-height: 56px;
    padding: 8px 16px;
    align-items: center;
`;

export const NoTouchPurchaseSummaryModalDetailsContainer = styled(Flex)`
    border-left: 1px solid ${colorsPalettes.carbon[50]};
    background-color: ${colorsPalettes.bluegrey[100]};
    align-items: center;
    flex-direction: column;
    width: 320px;
    padding: 24px 24px 24px 23px;
    border-radius: 0 0 8px 0;
    gap: 12px;
    justify-content: space-between;
`;
